import { ArrowSyncCircleRegular } from "@/pages/taskpane/components/icons/IconCustom";
import Accordion from "@/pages/taskpane/components/ui/Accordion";
import Button from "@/pages/taskpane/components/ui/Button";
import Select from "@/pages/taskpane/components/ui/Select";
import { useThemeStore } from "@/pages/taskpane/shared/stores";
import React, { useRef, useState } from "react";
import { PreSelectedResourceInfo } from "@/pages/taskpane/shared/types/preSelectedResource";

type Props = {
  notifyInfo?: PreSelectedResourceInfo;
};

const ProcessAlternative = ({ notifyInfo }: Props) => {
  const [isOpen, setIsOpen] = useState(true);
  const { isDarkMode } = useThemeStore();
  const checkboxRef = useRef<HTMLInputElement>(null);

  return (
    <Accordion
      isOpen={isOpen}
      onToggleOpen={() => setIsOpen(!isOpen)}
      className="shadow-elevationShadow4 dark:shadow-elevationShadow4Dark px-3 py-3 rounded-md flex flex-col"
      header={
        <div className="flex items-center gap-2">
          <div>
            <ArrowSyncCircleRegular isDarkMode={isDarkMode} />
          </div>
          <h2 className="text-sm font-semibold text-primaryBlue dark:text-brightBlue">Alternative Resource</h2>
        </div>
      }
      children={
        <div className="flex flex-col gap-1 pt-3">
          <div className="text-xs font-normal w-[100%] h-[32px] flex items-center bg-lightBlue dark:bg-midnightNavy rounded-md pl-3 pr-3">
            Number of conflicting occurrences 2/2
          </div>
          <div>
            <table className="w-full table-fixed">
              <thead>
                <tr className="h-[44px] border-b border-lightGray dark:border-darkMediumGray">
                  <th className="w-[24px] text-left">
                    <input type="checkbox" ref={checkboxRef} />
                  </th>
                  <th className="w-[40%] text-left text-sm font-semibold">Conflicting Dates</th>
                  <th className="text-left text-sm font-semibold">Alternative Resources</th>
                </tr>
              </thead>
              <tbody>
                <tr className="h-[56px]">
                  <td className="w-[24px] align-middle">
                    <input type="checkbox" />
                  </td>
                  <td className="w-[40%] align-middle">14/11/2025</td>
                  <td className="align-middle">
                    <Select
                      className="h-[32px] text-sm"
                      options={[
                        { label: "Resource 1", value: "resource1" },
                        { label: "Resource 2", value: "resource2" },
                      ]}
                      onChange={() => {}}
                      widthDropdown={200}
                      isSearch={true}
                      placeholder="Conflict"
                    />
                  </td>
                </tr>
                <tr className="h-[56px]">
                  <td className="w-[24px] align-middle">
                    <input type="checkbox" />
                  </td>
                  <td className="w-[40%] align-middle">14/11/2025</td>
                  <td className="align-middle h-[56px] flex items-center gap-2">
                    <Select
                      className="h-[32px] text-sm w-[100%]"
                      options={[
                        { label: "Resource 1", value: "resource1" },
                        { label: "Resource 2", value: "resource2" },
                      ]}
                      onChange={() => {}}
                      widthDropdown={200}
                      isSearch={true}
                      placeholder="Conflict"
                    />
                    {/* <Button
                      className="bg-primaryBlue text-white w-[40px] h-[32px] dark:bg-brightBlue dark:text-black text-xs"
                      iconButton={
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M8.5 4C7.84689 4 7.29127 4.4174 7.08535 5H5.5C4.67157 5 4 5.67157 4 6.5V18.5C4 19.3284 4.67157 20 5.5 20H12.2572C12.0035 19.6929 11.7826 19.3578 11.5997 19H5.5C5.22386 19 5 18.7761 5 18.5V6.5C5 6.22386 5.22386 6 5.5 6H7.08535C7.29127 6.5826 7.84689 7 8.5 7H11.5C12.1531 7 12.7087 6.5826 12.9146 6H14.5C14.7761 6 15 6.22386 15 6.5V11.207C15.3223 11.1159 15.6566 11.0534 16 11.0224V6.5C16 5.67157 15.3284 5 14.5 5H12.9146C12.7087 4.4174 12.1531 4 11.5 4H8.5ZM8 5.5C8 5.22386 8.22386 5 8.5 5H11.5C11.7761 5 12 5.22386 12 5.5C12 5.77614 11.7761 6 11.5 6H8.5C8.22386 6 8 5.77614 8 5.5ZM12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464C12.6583 10.9512 12.3417 10.9512 12.1464 11.1464L9 14.2929L7.85355 13.1464C7.65829 12.9512 7.34171 12.9512 7.14645 13.1464C6.95118 13.3417 6.95118 13.6583 7.14645 13.8536L8.64645 15.3536C8.84171 15.5488 9.15829 15.5488 9.35355 15.3536L12.8536 11.8536ZM21 16.5C21 18.9853 18.9853 21 16.5 21C14.0147 21 12 18.9853 12 16.5C12 14.0147 14.0147 12 16.5 12C18.9853 12 21 14.0147 21 16.5ZM17 14.5C17 14.2239 16.7761 14 16.5 14C16.2239 14 16 14.2239 16 14.5V16H14.5C14.2239 16 14 16.2239 14 16.5C14 16.7761 14.2239 17 14.5 17H16V18.5C16 18.7761 16.2239 19 16.5 19C16.7761 19 17 18.7761 17 18.5V17H18.5C18.7761 17 19 16.7761 19 16.5C19 16.2239 18.7761 16 18.5 16H17V14.5Z"
                            fill="white"
                          />
                        </svg>
                      }
                    /> */}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="flex justify-end gap-3 mt-4 pt-4 border-t border-lightGray dark:border-darkMediumGray">
            <Button
              className="bg-primaryBlue text-white w-[97px] h-[32px] dark:bg-brightBlue dark:text-black text-xs"
              label="OK"
              onClick={() => {}}
            />
            <Button
              className="bg-white text-black border border-lightGray w-[97px] h-[32px] dark:text-white dark:border-darkMediumGray text-xs"
              label="Cancel"
              onClick={() => {}}
            />
          </div>
        </div>
      }
    />
  );
};

export default ProcessAlternative;
